import { EntityStatus } from './views.interface';

export interface RegistrationUserBase {
  email: string;
  password: string;
  agree: boolean;
}

export interface RegistrationIndividualUser extends RegistrationUserBase {
  alias: string;
}

export interface RegistrationOrganizationUser extends RegistrationUserBase {
  organizationName: string;
}

export interface UserInfo {
  userId: string;
  userName: string;
  userImage: string;
  userStatus: EntityStatus;
}

export function equalUserInfos(u1: UserInfo, u2: UserInfo): boolean {
  return (
    u1.userId === u2.userId &&
    u1.userName === u2.userName &&
    u1.userImage === u2.userImage &&
    u1.userStatus === u2.userStatus
  );
}
